import React from "react";
import { APP_PREFIX_PATH } from "configs/AppConfig";

export const eventsRoutes = [
	{
		key: "event-submissions-backoffice",
		exact: true,
		path: `${APP_PREFIX_PATH}/events/submissions`,
		component: React.lazy(() => import("views/app-views/events/pages/EventSubmissionsBackoffice")),
	},
];
